import set from "@rill/set";
import moment from "moment";
import { getWeekPeriodFromDate } from "../../../utils/nutrition-helpers";
import {
  generateWeeks,
  formatWeekNumber,
  getDateFromWeek,
  getYearAndMonth,
  defaultFormat,
} from "./body-composition/body-composition.helper";
import BodyComposition from "./body-composition/BodyComposition";
import _ from "lodash";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import { isAdminOrOwner } from "../../../utils/organization-permissions-helpers";

const BodyCompositionController = (app) => {
  app.get(
    "/body-composition",
    set("heading", "Body Composition"),
    async ({ locals, res, req, load }) => {
      const calendarDay = locals.activeUser.startingCalendarDay || 0;
      //get proxyAthlete from query
      const { query = {} } = req;
      const { date, athlete, startDay, endDay } = query;
      const selectedWeek = query.selectedWeek
        ? parseInt(query.selectedWeek)
        : 1;

      const { year, month } = getYearAndMonth(startDay);

      const defaultWeeks = generateWeeks(year, month, calendarDay);

      const utcDate = String(date);
      const startOfPeriod = moment(utcDate);

      const daysToSubtract =
        moment(startOfPeriod).isoWeekday() >= calendarDay
          ? moment(startOfPeriod).isoWeekday() - calendarDay
          : 7 + moment(startOfPeriod).isoWeekday() - calendarDay;

      const startOfWeek = moment(startOfPeriod).subtract(
        daysToSubtract,
        "days"
      );

      const endOfWeek = moment(startOfWeek).add(6, "days");

      const defaultTargetWeek = {
        start: startOfWeek,
        end: endOfWeek,
      };

      const targetWeek = query.selectedWeek
        ? { start: moment(startDay), end: moment(endDay) }
        : defaultTargetWeek;

      const targetWeeksNumber = query.selectedWeek
        ? selectedWeek
        : defaultWeeks.length;

      const start = getDateFromWeek(targetWeek, "start");
      const end = getDateFromWeek(targetWeek, "end");

      const threeMonthStart = moment(start)
        .subtract(3, "months")
        .format(defaultFormat);

      const isAllowToViewAllOrganizationsAthletes = isAdminOrOwner(
        locals.organizationRoleName
      );

      if (
        locals.activeUser.organizationId &&
        isAllowToViewAllOrganizationsAthletes &&
        !locals.allAthletesFromOrganization
      ) {
        await load("allAthletesFromOrganization");
      }

      await Promise.all([
        load("activeExercises", {
          start,
          end,
          proxyAthlete: athlete,
          reqSource: "calendar",
        }),
        load("dailyStats", {
          proxyAthlete: athlete,
          start: threeMonthStart,
          end,
        }),
        load("nutritionPlans", {
          proxyAthlete: athlete,
        }),
      ]);

      const weekNumber = formatWeekNumber(selectedWeek);
      const modal = _.get(req.query, "modal", {});
      locals.modal = {
        "activity-feed": <ActivityDrawer />,
      }[modal.type];
      res.body = (
        <BodyComposition
          locals={locals}
          start={start}
          end={end}
          selectedWeek={weekNumber}
          weeksNumber={targetWeeksNumber}
        />
      );
    }
  );
};

export default BodyCompositionController;
